import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import { AuthLoading } from "@/components/auth/AuthLoading";

/** Redirects unauthenticated users to /login (preserving intended destination). */
export function RequireAuth() {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  if (status === "loading") return <AuthLoading />;
  if (status === "unauthed" || status === "pending_mfa") {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}
